
const init_hash_listener = () => {
  window.onhashchange = () => {
     // /checklists/153#task_13527.md
      const match = location.href.match(/\/checklists\/(\d+)[^#]*#task_(\d+)\.md/);
      if (match) {
          maxkir.info("Handle redirect to Markdown version")
          document.location.href = `/checklists/${match[1]}/tasks/${match[2]}.md`
      }
  }
}

export {init_hash_listener};